import moment from 'moment';

export default class DateFormater {
	
	/**
	 * Возвращает текущую дату в UTC
	 * @param withTime С временем
	 * @returns Date
	 */
	static getDateNow = ( withTime: boolean = true ): Date => {
		const date = new Date( Date.now() );
		if ( !withTime ) {
			date.setHours(0);
			date.setMinutes(0);
			date.setSeconds(0);
			date.setMilliseconds(0);
		}
		return this.dateOffset( date, withTime );
	};

	/**
	 * Сравнивает текущую дату и указанную
	 * @param value дата
	 * @param isNeedParse нужно ли парсить из строки
	 * @param orEquals или равны
	 * @returns True - Указанная дата меньше или равна текущей
	 */
	static dateIsNotMoreCurrent = ( value: Date | string, isNeedParse: boolean = false, orEquals: boolean = false ): boolean => {
		if ( !value ) return true;
		let date: Date;
		
		if ( typeof value === "string" || isNeedParse ) {
			date = this.dateOffset( moment( value, 'DD.MM.YYYY').toDate(), false );
		}
		else 
			date = new Date(value);

		const now = this.getDateNow( false );
		date.setHours(0, 0, 0, 0);
		now.setHours(0, 0, 0, 0);
		
		if ( orEquals )
			return date!.getTime() <= now.getTime();

		return date!.getTime() < now.getTime();
	};

	/**
	 * Сравнивает текущую дату и указанную
	 * @param value дата
	 * @param isNeedParse нужно ли парсить из строки
	 * @param orEquals или равны
	 * @returns True - Указанная дата меньше или равна текущей
	 */
	static dateIsNotMore = ( value: Date | string, value2: Date | string, isNeedParse: boolean = false, orEquals: boolean = false ): boolean => {
		let date: Date;
		
		if ( typeof value === "string" || isNeedParse ) {
			date = this.dateOffset( moment( value, 'DD.MM.YYYY').toDate(), false );
		}
		else 
			date = value;

		const now = this.getDateNow( false );
		
		if ( orEquals )
			return date!.getTime() <= now.getTime();

		return date!.getTime() < now.getTime();
	};

	/**
	 * Возвращает указанную дату с текущем смещением времени, если указан флаг withTime
	 */
	static dateOffset( value: Date, withTime: boolean ) {
		const date = moment(value);
		const offset = moment().utcOffset();
		const correctedDate = moment(date).subtract(offset, 'minutes').toDate();
		return withTime ? correctedDate : date.toDate();
	}


	static ruMonthNames = ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"];

	static parseOformatZoneOffset = (hours:number|string, minutes:number|string, sign?:string) => {
		return ((sign === '-') ? -1 : 1) * ((~~hours * 60) + (~~minutes));
	};

	static getDateWithoutTimeZoneConvertion = (inputDateStr:string|Date) => {
		let date = new Date(inputDateStr);
		if (!!date) {
			//user timezone offset
			let userOffset;
			//input timezone offset
			let offset;
			if (inputDateStr instanceof Date) {
				//userOffset = date.getTimezoneOffset(); // user's offset time
				//offset = inputDateStr.getTimezoneOffset();
				//date = new Date(date.getTime() + (userOffset - offset) * 60 * 1000);
				return date;
			}
			if (typeof inputDateStr === 'string') {
				var match = (/[.](?:[0-9]+)([+]|[-])([\d]{2}):([\d]{2})$/).exec(inputDateStr);
				if (match) {
					userOffset = date.getTimezoneOffset(); // user's offset time
					offset = -1 *(match[1] === '' || match[1] === 'z' || match[1] === 'Z' ? 0 : this.parseOformatZoneOffset(match[2], match[3], match[1]));
					date = new Date(date.getTime() + (userOffset - offset) * 60 * 1000);
				}
			}
		}
		return date;
	};

	static getDate = (inputDateStr:string|Date, options?:any) => {
		return (!options || !options.useTimezone) ? 
			this.getDateWithoutTimeZoneConvertion(inputDateStr) : 
			new Date(inputDateStr);
	};

	static toFullDateString = (inputDateStr:string, options?:any) => {
		if (inputDateStr !== '') {
			var date = this.getDate(inputDateStr, options);
			var dateToShow = '';
			if (!isNaN(date.getTime()))
				dateToShow = (date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())) + ' ' + this.ruMonthNames[(date.getMonth())] + ' ' + date.getFullYear() + ' в ' + date.getHours() + ":" + (date.getMinutes() >= 10 ? date.getMinutes() : ('0' + date.getMinutes()));
				return dateToShow;
		}
		return '';
	};

	static toDateWithTimeString = (inputDateStr:string, options?:any) => {
		if (inputDateStr !== '') {
			var date = this.getDate(inputDateStr, options);
			if (!isNaN(date.getTime())) {
				return moment( date ).format( "DD.MM.yyyy HH:mm" );
			}
		}
		return '';
	};

	static toDateWithTimeString2 = (inputDateStr:string, options?:any) => {
		if (inputDateStr !== '') {
			var date = this.getDate(inputDateStr, options);
			if (!isNaN(date.getTime())) {
				return moment( date ).format( "DD.MM.yyyy - HH:mm" );
			}
		}
		return '';
	};

	static toDateString = (inputDateStr:string|Date, options?:any) => {
		if (inputDateStr !== '') {

			var date = this.getDate(inputDateStr, options);
			return (date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())) + " " + this.ruMonthNames[(date.getMonth())] + " " + date.getFullYear();
		}
		return '';
	};

	static toShortString = (inputDateStr:string|Date|null, options?:any) => {
		if ( !inputDateStr )
			return '';
		const date = this.getDate(inputDateStr, options);
		return moment(date).format("DD.MM.yyyy");
	};

	static toString = (inputDateStr:string|Date|null, options?:any) => {
		if ( !inputDateStr )
			return '';
		const date = this.getDate(inputDateStr, options);
		return moment(date).format("DD.MM.yyyy, hh:mm:ss");
	};

	/** Парсит дату из строки  */
	static parseDate = ( value: any, needParse: boolean = false ): Date|null => {
		if ( !value )
			return null;
		if ( typeof value === "object" && !!value.getDay )
			return value;
		if ( needParse ) {
			const date = moment.parseZone( value, 'DD.MM.YYYY').toDate();
			date.setHours(0);
			return date;
		}
		const date = new Date(value);
		date.setMinutes(0);
		date.setHours(0);
		date.setSeconds(0);
		date.setMilliseconds(0);
		return date;
	};

	static toString_ddMMyyyy = (date:Date) => {
		return (date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())) + " " + this.ruMonthNames[(date.getMonth())] + " " + date.getFullYear();
	};
}; 